module.exports = __webpack_public_path__ + "static/webDashboard-5965ed54f4fcd758f900295b46a0d858.png";